import { FlexRow } from '@make-software/cspr-design';
import styled from 'styled-components';

export const RootView = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    width: '100vw',
    textAlign: 'center',
  })
);
